import './spincrement.js';
const verge = require('verge');
const imagesLoaded = require('imagesloaded');
const cookie = require('cookie_js');

// CHECK WINDOW WIDTH
function inWidth(maxWidth = 768, minWidth = 0) {
	let currentWidth = verge.viewportW();
	if (maxWidth >= currentWidth && minWidth < currentWidth) {
		return true;
	} else {
		return false;
	}
}

// provide jQuery argument
imagesLoaded.makeJQueryPlugin($);

let App = App || {};

App.bps = {};
App.bps.point = 768;

function checkWindowWidth() {
	//check window width (scrollbar included)
	let e = window,
		a = 'inner';
	if (!('innerWidth' in window)) {
		a = 'client';
		e = document.documentElement || document.body;
	}
	if (e[ a + 'Width' ] >= App.bps.point) {
		return true;
	} else {
		return false;
	}
}


let $topSlide = $('.js-first-slide'),
	$topImg = $topSlide.find('img'),
	$topText = $('.js-top-text'),
	$blockScrollAnimated = $('.js-scroll-animated'),
	$indicators = $('.indicator:not(".indicator--power")'),
	$infoCard = $('.z-page-infocard__card'),
	$infoHand = $('.z-page-infocard__hand'),
	$infoText = $('.z-page-infocard__text'),
	$npFeature = $('.z-page-feature'),
	$npBusinessSide = $('.business-side'),
	$npPower = $('#z-page-power-object'),
	$npDigits = $('.js-digit');

//
// Power SPIDOMETR
//

if ($npPower.length) {
	$(window).on('load', function () {
		var powerObject = document.getElementById("z-page-power-object");
		var powerSVG = powerObject.contentDocument;
		var powerShadow = powerSVG.getElementById('shadow');

		$('#z-page-power').viewportChecker({
			classToAdd: 'is-animate',
			offset: "10%",
			callbackFunction: function(elem, action) {
				$npPower.addClass('is-animate');

				$(powerShadow).velocity({
					opacity: 1
				}, {
					delay: 250,
					duration: 300,
					easing: 'linear'
				});

				$(elem)
					.find('.js-z-page-inc').spincrement({
						decimalPoint: ",",
						thousandSeparator: "",
						// easing: 'linear',
						duration: 2000
					});
			}
		})
	})
}

//
// SET ATTR WIDTH AND HEIGHT FOR TOP IMG
//
let topImgRatio = 1.6;

function setWidthTopSlide() {
	let topSlideRatio = $topSlide.outerWidth() / $topSlide.outerHeight(),
		outputWidth = $topSlide.outerWidth() + 1,
		outputHeight = $topSlide.outerHeight() + 1;

	if (topSlideRatio > topImgRatio) {
		$topImg.css({
			width: outputWidth + 'px',
			height: 'auto'
		});
	} else {
		$topImg.css({
			width: 'auto',
			height: outputHeight + 'px'
		});
	}
}
setWidthTopSlide();
//
// end SET ATTR WIDTH AND HEIGHT FOR TOP IMG
//


if (!inWidth()) { // Check for screen with
	animationInit();
}

$(window).on('resize', function () {
	setWidthTopSlide();
	animationInit();
});

function getDecimalPlaces (number) {
	if (!number || !number.toString().includes('.')) return 0
	return number.toString().split('.')[1].length
}

function animationInit() {
	$topSlide.imagesLoaded({},
		function () {
			setTimeout(function () {
				$topSlide.addClass('is-animate');
				$topText.addClass('is-animate');
			}, 200);
		}
	);

	let arrBlocks = [$blockScrollAnimated, $infoCard, $infoHand, $infoText, $npBusinessSide, $npFeature, $indicators, $npDigits];

	arrBlocks.forEach(function (item, i, arr) {
		let npMapCenter, npMapZoom, npMapBaloon;
		item.viewportChecker({
			classToAdd: 'is-animate',
			offset: '0%',
			callbackFunction: function (elem, action) {
				const lang = getLang();
				let thousandSeparator = lang === 'en' ? ',' : '';
				let decimalPoint = ',';
				const text = $(elem).find('.js-z-page-inc').text();

				if (lang === 'en') {
					$(elem).find('.js-z-page-inc').text(text.replace('.', ','));
					decimalPoint = '.';
				}

				if ($(elem).find('.js-z-page-inc').data('thousandseparator')) {
					thousandSeparator = $(elem).find('.js-z-page-inc').data('thousandseparator');
				}

				let decimalPlaces = getDecimalPlaces($(elem).find('.js-z-page-inc').data('to'));

				$(elem).find('.js-z-page-inc').spincrement({
					decimalPoint: decimalPoint,
					thousandSeparator: thousandSeparator,
					// easing: 'linear',
					duration: 2000,
					leeway: 20,
					decimalPlaces: decimalPlaces
				});

				if ($(elem).attr('id') === 'z-page-map' && cookie.get('marketing') === 'true') {
					let myMap,
						myPlacemark;

					function init() {
						myMap = new ymaps.Map('z-page-map', {
							center: [0, 0],
							zoom: 5,
							controls: ['zoomControl']
						});
						npMapCenter = myMap.container._parentElement.dataset.center;
						npMapZoom = myMap.container._parentElement.dataset.zoom;
						npMapBaloon = myMap.container._parentElement.dataset.ballontext;

						// Создание метки со сложной фигурой активной области.
						let polygonLayout = ymaps.templateLayoutFactory.createClass('<div class="placemark-layout-container"><div class="placemark-layout"><span>' + npMapBaloon + '</span></div></div>');

						let myPlacemark = new ymaps.Placemark(
							npMapCenter.split(','), {}, {
								iconLayout: polygonLayout
							}
						);
						myMap.setCenter(npMapCenter.split(','), npMapZoom);
						myMap.behaviors.disable('scrollZoom');
						myMap.geoObjects.add(myPlacemark);
					}

					function mapSize() {
						let mapRatio = 1.85,
							$npMap = $('.js-z-page-map');
						$npMap.height($npMap.width() / mapRatio);
					}

					mapSize();
					ymaps.ready(init);

					$(window).on('resize', function () {
						mapSize();
						let desktop = checkWindowWidth();
						if (desktop) {
							myMap.setCenter(npMapCenter.split(','), npMapZoom);
						}
					});
				}
			}
		});
	});
}

$('.js-scroll-link').on('click touchstart', function (e) {
	e.preventDefault();
	let target = $(this).attr('href'),
		$targetSection = $('.js-scroll-section[data-section-id="'+target+'"]'),
		offsettop = -40;

	if ($targetSection.data('offsettop') != undefined) {
		offsettop = $targetSection.data('offsettop');
	}

	$targetSection.velocity('scroll', {
		duration: 400,
		offset: offsettop,
		easing: 'ease-in-out'
	});
});



// WEBPACK FOOTER //
// ./frontend/components/animation/animation.js